import React from "react";
import { observer } from "mobx-react";
import { Button } from "@mui/material";
import { EditIcon } from "../../../icons";
import { useRootStore } from "../../../store/contexts";

type EditFormProps = {
  onClick: () => void;
  disabled?: boolean;
  label?: string;
};

export const EditFormButton: React.FC<EditFormProps> = observer(
  ({ onClick, disabled, label }) => {
    const rootStore = useRootStore();
    const { prefStore, langStore } = rootStore;

    return (
      <Button
        variant={"action"}
        size={prefStore.toolbarSize}
        startIcon={<EditIcon />}
        disabled={disabled === undefined ? false : disabled}
        onClick={onClick}
      >
        {!label ? langStore.editForm : label}
      </Button>
    );
  }
);
